import React, { useEffect } from 'react';
import { PageHeader, Skeleton, Result } from 'antd';
import history from '@utils/history';
import PropTypes from 'prop-types';

import { UserForm } from '@containers/users';
import UsersActions, { UsersSelectors } from '@redux/UsersRedux';
import { connect } from 'react-redux';

function EditUserPage(props) {
  const {
    loadig,
    userData,
    loadUser,
    resetUser,
    match: { params }
  } = props;

  const { id: userId } = params || {};

  useEffect(() => {
    loadUser(userId);

    return () => {
      resetUser();
    };
  }, [userId]);

  const render404 = () => {
    return (
      <div className="users main-page">
        <PageHeader
          title="User"
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="Users main-content">
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
          />
        </div>
      </div>
    );
  };

  if (loadig) {
    return (
      <div className="users main-page">
        <PageHeader
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="coupon main-content">
          <Skeleton />
        </div>
      </div>
    );
  }

  const { userID: loadedId, firstName, lastName } = userData || {};
  if (!loadedId) {
    return render404();
  }
  const title = `${firstName} ${lastName}`;

  return (
    <div className="users main-page">
      <PageHeader
        title={title}
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
        onBack={() => history.goBack()}
      />
      <div className="main-content">
        <UserForm userId={params.id} userData={userData} />
      </div>
    </div>
  );
}

EditUserPage.propTypes = {
  match: PropTypes.object,
  loadUser: PropTypes.func,
  resetUser: PropTypes.func,
  loadig: PropTypes.bool,
  userData: PropTypes.object,
  firstName: PropTypes.string,
  lastName: PropTypes.string
};

const mapDispatchToProps = dispatch => ({
  loadUser: userId => {
    dispatch(UsersActions.loadUserRequest(userId));
  },
  resetUser: () => {
    dispatch(UsersActions.setUserData(null));
  }
});

const mapStateToProps = state => ({
  loadig: UsersSelectors.selectLoading(state),
  userData: UsersSelectors.selectUserData(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditUserPage);
